import React, { useEffect, useState } from "react";
import apiService from "src/services/api.service";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SingleSelectWithToggle from "src/components/SingleSelectWithToggle";
import { format } from "date-fns";
import OffersSelect from "./OffersSelect";

const ChooseDay = (props) => {
  const [days, setDays] = useState([]);
  const [customDay, setCustomDay] = useState(null);
  const [day, setDay] = useState(1);
  const [type, setType] = useState("Automatic");
  const [startDate, setStartDate] = useState();
  const [openOffer, setOpenOffer] = useState(false);
  const [offerList, setOfferList] = useState([]);
  const [searchedOfferList, setSearchedOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState();
  const [openCreative, setOpenCreative] = useState(false);
  const [creativeList, setCreativeList] = useState([]);
  const [filteredCreativeList, setFilteredCreativeList] = useState([]);
  const [selectedCreative, setSelectedCreative] = useState();
  const [searchOffer, setSearchOffer] = useState();
  const [searchCreative, setSearchCreative] = useState();

  useEffect(() => {
    apiService.getAllOffers().then((response) => {
      setOfferList(response.data);
      setSearchedOfferList(response.data);
    });
    apiService.getAllCreatives().then((response) => {
      setCreativeList(response.data);
    });
  }, []);

  useEffect(() => {
    const filtered = offerList?.filter((item) => {
      const itemName = item?.name?.toLowerCase?.() || "";
      const searchTerm = searchOffer?.toLowerCase?.() || "";
      return itemName.includes(searchTerm);
    });
    setSearchedOfferList(filtered || []);
  }, [searchOffer]);

  useEffect(() => {
    const today = startDate ? new Date(startDate) : new Date();
    let daysInfo = [];
    let day = today;
    for (let i = 0; i < 10; i++) {
      daysInfo.push({
        dayOfWeek: new Intl.DateTimeFormat("en-US", {
          weekday: "short",
        }).format(new Date(day?.getFullYear(), day?.getMonth(), day.getDate())),
        dayOfMonth: day.getDate(),
      });
      day.setDate(today.getDate() + 1);
    }
    setDays(daysInfo);
  }, [startDate]);

  useEffect(() => {
    setStartDate(dayjs(props.startDate));
  }, [props.startDate]);

  useEffect(() => {
    if (selectedOffer) {
      setFilteredCreativeList(
        creativeList?.filter(
          (creative) =>
            creative.offer_id?._id === selectedOffer?._id &&
            creative?.type === props.creativeType &&
            creative?.name
              ?.toLowerCase()
              ?.search(searchCreative?.toLowerCase()) !== -1
        )
      );
    }
  }, [selectedOffer, searchCreative, props.chosenLists]);

  const createCalendar = () => {
    if (type === "Manual") {
      apiService
        .createCalendarManual({
          list_ids: props.chosenLists?.map((item) => item._id),
          days: customDay ? customDay : day,
          start_date: startDate
            ? format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss")
            : format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
          offer_id: selectedOffer?._id,
          creative_id: selectedCreative?._id,
        })
        .then(() => {
          props.close();
          props.setIsUpdate(true);
        });
    } else {
      apiService
        .createCalendar({
          list_ids: props.chosenLists?.map((item) => item._id),
          days: customDay ? customDay : day,
          start_date: startDate
            ? format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss")
            : format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
        })
        .then(() => {
          props.close();
          props.setIsUpdate(true);
        });
    }
  };

  const handleCustom = (numberOfDay) => {
    setCustomDay(numberOfDay);
  };

  const handleDay = (index) => {
    setDay(index + 1);
  };

  const handleType = (calendarType) => {
    setType(calendarType);
  };

  const handleSelectOffer = () => {
    setOpenOffer(true);
  };

  const handleSelectCreative = () => {
    setOpenCreative(true);
  };

  const closeModals = () => {
    setOpenOffer(false);
    setOpenCreative(false);
  };

  const isDisable = () => {
    if (type === "Manual") {
      return !(selectedOffer && selectedCreative);
    } else return false;
  };

  const selectedListTagIds = props.chosenLists
    ?.flatMap((list) => list?.tag_ids || [])
    ?.map((tag) => (typeof tag === "object" ? tag?._id : tag))
    ?.filter(Boolean);

  return (
    <div className="NewScheduleChooseDayModal">
      <div className={"w-full flex justify-between"}>
        <div className={"NewStrategy"}>
          <img
            alt={"Logo"}
            src={"/media/icons/purplePlusIcon.svg"}
            className={"w-[18px] h-[18px]"}
          />
          New Schedule
        </div>
        <button className={"CloseIconButton"} onClick={props.close}>
          <img
            alt={"Logo"}
            src={"/media/icons/closeIcon.svg"}
            className={"w-5 h-5"}
          />
        </button>
      </div>
      <div className={"CalendarNewScheduleListNameBoxes"}>
        {props.chosenLists?.map((list) => (
          <div className={"CalendarNewScheduleListNameBox"}>
            <div className={"flex gap-1 items-center"}>
              <img
                alt={"Logo"}
                src={"/media/icons/rows.svg"}
                className={"w-[14px] h-[14px]"}
              />
              <div className={"DashboardListNameTitle"}>List Name:</div>
              <div className={"SMSEmailBoxListName"}>{list.name}</div>
            </div>
            {props.chosenLists?.length !== 1 && (
              <button onClick={() => props.deleteList(list)}>
                <img
                  alt={"Logo"}
                  src={"/media/icons/closeIcon.svg"}
                  className={"w-[18px] h-[18px]"}
                />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className={"flex flex-col gap-4 w-full"}>
        <div className={"HorizontalDivider"}></div>
        <div className={"NewListTypeButtons"}>
          <button
            onClick={() => handleType("Automatic")}
            className={
              type === "Automatic" ? "NewListChosenButton" : "NewListButton"
            }
          >
            Automatic
            {type === "Automatic" && (
              <span className={"ChosenMarkerListType"}></span>
            )}
          </button>
          <img
            alt={"Logo"}
            src={"/media/icons/separate.png"}
            className={"h-[22px] w-[1px]"}
          />
          <button
            onClick={() => handleType("Manual")}
            className={
              type === "Manual" ? "NewListChosenButton" : "NewListButton"
            }
          >
            Manual
            {type === "Manual" && (
              <span className={"ChosenMarkerListType"}></span>
            )}
          </button>
        </div>
        <div className={"NewScheduleTitles"}>
          {type === "Automatic" ? "Start Date" : "Date"}
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            renderInput={(params) => <TextField {...params} />}
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            sx={{
              "fieldset.MuiOutlinedInput-notchedOutline": {
                border: "1px solid #E5E7F0",
                borderRadius: "8px",
              },
              "input.MuiOutlinedInput-input": {
                padding: "0 8px",
                fontSize: "12px",
                height: "36px",
              },
            }}
          />
        </LocalizationProvider>
        {type === "Automatic" ? (
          <div className={"flex flex-col gap-4 w-full"}>
            <div className={"NewScheduleTitles"}>Choose Days</div>
            <div className={"NewScheduleChooseDayBoxes"}>
              {days?.map((item, index) => (
                <button
                  className={
                    customDay
                      ? "ChooseDayDisableButton"
                      : index < day && day === 1 && index === 0
                      ? "ChooseDayChosenButton"
                      : index < day && index + 1 === day
                      ? "ChooseDayChosenLastButton"
                      : index < day && index < day - 1
                      ? "ChooseDayChosenBetweenButton"
                      : "ChooseDayButton"
                  }
                  onClick={() => handleDay(index)}
                  disabled={customDay}
                >
                  <div
                    className={
                      customDay
                        ? "ChooseDayDisableButtonNumberOfIndex"
                        : index < day
                        ? "ChooseDayChosenButtonNumberOfIndex"
                        : "ChooseDayButtonNumberOfIndex"
                    }
                  >
                    {index + 1}
                  </div>
                  <div className={"ChooseDayHorizontalDivider"}></div>
                  <div
                    className={
                      customDay
                        ? "ChooseDayDisableButtonNumberOfIndex"
                        : index < day
                        ? "ChooseDayChosenButtonNumberOfIndex"
                        : "ChooseDayButtonNumberOfIndex"
                    }
                  >
                    <div>{item.dayOfWeek}</div>
                    <div>{item.dayOfMonth}</div>
                  </div>
                </button>
              ))}
            </div>
            <div className={"ChooseDayOr"}>or</div>
            <input
              className={"NewStrategyInput"}
              type="number"
              placeholder="Custom"
              onChange={(e) => handleCustom(e.target.value)}
              value={customDay}
            />
            <div className={"NewStrategyInputSection"}>
              <div className={"NewStrategyInputTitle"}>Strategy ID</div>
              <input
                className={"NewStrategyStrategyIdInput"}
                disabled
                type="text"
                placeholder={
                  props.list?.strategy_id?.name
                    ? props.list?.strategy_id?.name
                    : "Default Strategy"
                }
              />
            </div>
          </div>
        ) : (
          <div className={"flex flex-col gap-4 w-full"}>
            <div className={"NewScheduleTitles"}>Offer</div>
            {openOffer ? (
              <OffersSelect
                list={searchedOfferList}
                listTagIds={selectedListTagIds}
                selectedItem={selectedOffer}
                setSelectedItem={setSelectedOffer}
                close={closeModals}
                img={"/media/icons/offer.svg"}
                pauseImg={"/media/icons/offerActive.svg"}
                playImg={"/media/icons/offerPaused.svg"}
                title={"Offers"}
                titleImg={"/media/icons/offerPurple.svg"}
                search={searchOffer}
                setSearch={setSearchOffer}
              ></OffersSelect>
            ) : (
              <button
                className={"OfferCreativeSelectButton"}
                onClick={() => handleSelectOffer()}
              >
                {selectedOffer ? (
                  <div className={"text-xs font-medium"}>
                    {selectedOffer.name}
                  </div>
                ) : (
                  "Select"
                )}
                <img
                  alt={"Logo"}
                  src={"/media/icons/chevronDown.svg"}
                  className={"w-[18px] h-[18px]"}
                />
              </button>
            )}
            <div className={"NewScheduleTitles"}>Creative</div>
            {openCreative ? (
              <SingleSelectWithToggle
                list={filteredCreativeList}
                selectedItem={selectedCreative}
                setSelectedItem={setSelectedCreative}
                close={closeModals}
                img={"/media/icons/creative.svg"}
                title={"Creative"}
                titleImg={"/media/icons/creativePurple.svg"}
                search={searchCreative}
                setSearch={setSearchCreative}
              ></SingleSelectWithToggle>
            ) : (
              <button
                className={"OfferCreativeSelectButton"}
                onClick={() => handleSelectCreative()}
              >
                {selectedCreative ? (
                  <div className={"SelectedTags"}>{selectedCreative.name}</div>
                ) : (
                  "Select"
                )}
                <img
                  alt={"Logo"}
                  src={"/media/icons/chevronDown.svg"}
                  className={"w-[18px] h-[18px]"}
                />
              </button>
            )}
          </div>
        )}
      </div>
      <div className={"HorizontalDivider"}></div>
      <div className="flex justify-between items-center w-full">
        <button className={"SecondaryButton"} onClick={props.handleBack}>
          <img
            alt={"Logo"}
            src={"/media/icons/arrowLeft.svg"}
            className={"w-4 h-4"}
          />
          Back
        </button>
        <div className={"flex gap-3"}>
          <button type="button" onClick={props.close} className="CloseButton">
            Close
          </button>
          <button
            disabled={isDisable()}
            type="submit"
            className="CreateButton"
            onClick={createCalendar}
          >
            {"Create"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseDay;
